export const getRecipes = '/recipes/getRecipesWithPayload/{payload}?payload=';
